import { render, staticRenderFns } from "./tankList.vue?vue&type=template&id=2cf9519e&"
import script from "./tankList.vue?vue&type=script&lang=ts&"
export * from "./tankList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports